import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLoginModal } from '../context/LoginModalContext';
import { landingRouteFor } from '../utils/auth';
import { MONO, SANS } from '../constants/fonts';

const SIGN_UP_ENABLED = process.env.NODE_ENV === 'development';

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: 20,
  },
  card: {
    position: 'relative',
    width: '100%',
    maxWidth: 380,
    background: '#fff',
    border: '1px solid #e5e5ea',
    borderRadius: 16,
    padding: 32,
    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
    fontFamily: SANS,
  },
  close: {
    position: 'absolute',
    top: 12,
    right: 14,
    background: 'none',
    border: 'none',
    fontSize: '1.2rem',
    lineHeight: 1,
    color: '#999',
    cursor: 'pointer',
  },
  title: {
    fontFamily: MONO,
    fontSize: '1.3rem',
    marginBottom: 6,
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '0.85rem',
    color: '#888',
    textAlign: 'center',
    lineHeight: 1.5,
    margin: '0 0 24px',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    marginBottom: 12,
    borderRadius: 8,
    border: '1px solid #d5d5da',
    fontSize: '0.95rem',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '10px 12px',
    marginBottom: 12,
    borderRadius: 8,
    border: 'none',
    background: '#111',
    color: '#fff',
    fontSize: '0.95rem',
    cursor: 'pointer',
  },
  toggle: {
    background: 'none',
    border: 'none',
    color: '#555',
    cursor: 'pointer',
    fontSize: '0.85rem',
    textDecoration: 'underline',
    display: 'block',
    margin: '0 auto',
  },
  error: {
    color: '#c0392b',
    fontSize: '0.85rem',
    marginBottom: 12,
    textAlign: 'center',
  },
};

export default function LoginModal() {
  const { isOpen, closeLogin } = useLoginModal();
  const { signInWithEmail, signUpWithEmail } = useAuth();
  const navigate = useNavigate();
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => { if (e.key === 'Escape') closeLogin(); };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen, closeLogin]);

  useEffect(() => {
    if (!isOpen) {
      setIsSignUp(false);
      setEmail('');
      setPassword('');
      setError('');
      setSubmitting(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const credential = SIGN_UP_ENABLED && isSignUp
        ? await signUpWithEmail(email, password)
        : await signInWithEmail(email, password);
      closeLogin();
      navigate(landingRouteFor(credential.user));
    } catch (err) {
      setError(err.message.replace('Firebase: ', ''));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={styles.overlay} onClick={closeLogin}>
      <div style={styles.card} onClick={(e) => e.stopPropagation()}>
        <button type="button" style={styles.close} aria-label="Close" onClick={closeLogin}>
          &times;
        </button>

        <div style={styles.title}>{SIGN_UP_ENABLED && isSignUp ? 'Create account' : 'Sign in'}</div>
        <p style={styles.subtitle}>Our client area is for existing clients only</p>

        {error && <div style={styles.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
          />
          <button type="submit" style={styles.button} disabled={submitting}>
            {SIGN_UP_ENABLED && isSignUp ? 'Sign up' : 'Sign in'}
          </button>
        </form>
{/* 
        {SIGN_UP_ENABLED && (
          <button
            type="button"
            style={styles.toggle}
            onClick={() => { setIsSignUp((prev) => !prev); setError(''); }}
          >
            {isSignUp ? 'Already have an account? Sign in' : 'Need an account? Sign up'}
          </button>
        )} */}
      </div>
    </div>
  );
}
